<form class="row float-right">
    <div class="col form-floating mb-3">
        <input type="number" class="form-control" id="popularity" aria-describedby="popularity" min=0>
        <label class="form-label" for="popularity">Popularity</label>
    </div>
    <div class="col mb-3">
        <button class="btn btn-dark">Apply</button>
    </div>
</form>